/** Mirror of apps/api/src/app/schemas/analysis/slabs.py */

import type { LiveLoadUse, SupportType, CombinationKind } from '../beams/types';

export type SlabAnalysisType =
  | 'aligerada_1d'
  | 'maciza_1d'
  | 'aligerada_2d'
  | 'maciza_2d';

export type EdgeCondition = 'simple' | 'continuo';

export interface SlabAnalysisGeometry {
  type: SlabAnalysisType;
  Lx_m: number;
  Ly_m: number;
  thickness_cm: number;
  bw_cm: number;
  rib_spacing_cm: number;
  t_slab_cm: number;
}

export interface SlabAnalysisAutoLoads {
  use: LiveLoadUse;
  acabados_kgf_m2: number;
  tabiqueria_kgf_m2: number;
  cielo_raso_kgf_m2: number;
  custom_live_load_kgf_m2?: number | null;
}

export interface OneWayContinuity {
  support_type: SupportType;
}

export interface TwoWayEdges {
  bottom: EdgeCondition;
  top: EdgeCondition;
  left: EdgeCondition;
  right: EdgeCondition;
}

export interface SlabAnalysisRequest {
  geometry: SlabAnalysisGeometry;
  auto_loads: SlabAnalysisAutoLoads;
  one_way: OneWayContinuity;
  two_way_edges: TwoWayEdges;
  combo: CombinationKind;
  fc: number;
  fy: number;
  cover_cm: number;
}

export interface SlabLoadBreakdown {
  q_slab_self: number;
  q_finishes: number;
  q_partitions: number;
  q_ceiling: number;
  q_D_surface: number;
  q_L_surface: number;
  w_u_surface: number;
}

export interface OneWayMoments {
  Mu_neg_left: number;
  Mu_pos_mid: number;
  Mu_neg_right: number;
  Vu: number;
}

export interface TwoWayMoments {
  case_number: number;
  m: number;
  Mu_a_neg: number;
  Mu_a_pos: number;
  Mu_b_neg: number;
  Mu_b_pos: number;
}

export interface SlabDesignPrefill {
  type: SlabAnalysisType;
  L_span_cm: number;
  h_total_cm: number;
  bw_cm: number;
  s_rib_cm: number;
  t_slab_cm: number;
  continuity: string;
  WD_kgf_m2: number;
  WL_kgf_m2: number;
}

export interface SlabAnalysisResponse {
  breakdown: SlabLoadBreakdown;
  behavior: 'one_way' | 'two_way';
  Ly_over_Lx: number;
  one_way: OneWayMoments | null;
  two_way: TwoWayMoments | null;
  governing_combo: string;
  warnings: string[];
  design_prefill: SlabDesignPrefill;
}

export const SLAB_TYPE_LABELS: Record<SlabAnalysisType, string> = {
  aligerada_1d: 'Aligerada — una dirección',
  maciza_1d: 'Maciza — una dirección',
  aligerada_2d: 'Aligerada — dos direcciones',
  maciza_2d: 'Maciza — dos direcciones',
};
